<script>
/**
* @overview 游戏预览
*
* @author huojinzhao
*/

import { previewGameUrl } from "@/utils";
// eslint-disable-next-line import/extensions
import token from "@/utils/token";

export default {
  name: "GamePreview",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
    type: {
      type: Number,
      default: null,
    },
    question_type: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    dataUrl: "",
  }),
  mounted() {
    const data = JSON.stringify(this.data);
    if (this.type === 30) {
      this.dataUrl = `${this.data.preview_url}`;
    } else {
      this.dataUrl = `${previewGameUrl}?type=${this.type}&id=${this.data.id}&token=${token.get()}`;
    }
    window.onmessage = e => this.handleMessage(e); // 监听iframe回调事件
  },
  methods: {
    cancel() {
      this.$emit("update:visible", false);
    },
    // 监听iframe回调
    handleMessage(res) {
      // console.log("message", res.data);
      const _this = this;
      switch (res.data.cmd) {
        // 游戏开始发送数据
        case "postData":
          console.log("发送数据");
          _this.$refs.iframe.contentWindow.postMessage(
            { type: "postData", data: _this.data },
            "*",
          );
          break;
        // 开始录音
        case "BeginLuYin":
          _this.start();
          break;
          // 结束录音
        case "StopLuYin":
          _this.stop();
          break;
      }
    },
    // 开始录音
    start() {
      console.log("开始");
    },
    // 停止录音
    stop() {
      console.log("结束");
      this.postData();
    },
    // 发送评分
    postData() {
      console.log("发送数据", "shouData", 100);
      const data = {
        tokenId: "9269894a6a143224",
        applicationId: "t195",
        audioUrl: "http://files.cloud.ssapi.cn:8080/t195/11e9b27d7a1b582ea8aat19522119a63",
        params: {
          app: {
            timestamp: "1564458712",
            userId: "2317",
            applicationId: "t195",
            sig: "f20b122e2b1a60d591345f7aed89a76f8b2c92ba",
          },
          audio: {
            sampleBytes: 2,
            audioType: "ogg",
            sampleRate: 16000,
            channel: 1,
          },
          request: {
            typeThres: 2,
            tokenId: "9269894a6a143224",
            coreType: "en.word.score",
            attachAudioUrl: 1,
            precision: 1,
            refText: "Japanese",
            rank: 100,
          },
        },
        recordId: "11e9b27d7a1b582ea8aat19522119a63",
        refText: "Japanese",
        result: {
          pron: 88,
          forceout: 0,
          precision: 1,
          systime: 226,
          res: "eng.wrd.online.0.2",
          version: "0.0.80.2019.6.5.11:39:56",
          info: {
            tipId: 0,
            clip: 0,
            snr: 11.489624,
            volume: 94,
          },
          rank: 100,
          delaytime: 27,
          wavetime: 2070,
          details: [
            {
              stress: [
                {
                  ref: 0,
                  score: 1,
                  char: "jh_ae",
                },
                {
                  ref: 0,
                  score: 0,
                  char: "p_ax",
                },
                {
                  ref: 1,
                  score: 0,
                  char: "n_iy_z",
                },
              ],
              char: "Japanese",
              dur: 950,
              score: 88,
              phone: [
                {
                  char: "jh",
                  score: 96,
                  end: 940,
                  start: 780,
                },
                {
                  char: "ae",
                  score: 95,
                  end: 1030,
                  start: 940,
                },
                {
                  char: "p",
                  score: 97,
                  end: 1140,
                  start: 1030,
                },
                {
                  char: "ax",
                  score: 94,
                  end: 1190,
                  start: 1140,
                },
                {
                  char: "n",
                  score: 34,
                  end: 1260,
                  start: 1190,
                },
                {
                  char: "iy",
                  score: 99,
                  end: 1480,
                  start: 1260,
                },
                {
                  char: "z",
                  score: 99,
                  end: 1730,
                  start: 1480,
                },
              ],
              end: 1730,
              start: 780,
            },
          ],
          pretime: 84,
          overall: 88,
        },
        dtLastResponse: "2019-07-30 11:52:40:334",
        eof: 1,
      };
      this.$refs.iframe.contentWindow.postMessage(
        { type: "shouData", data: data.result },
        "*",
      );
    },
  },
};
</script>

<template>
  <el-dialog
    :show-close="false"
    :visible="visible"
    class="game-list-editor"
    width="1000px"
  >
    <div slot="title">
      {{ '游戏预览' }}
    </div>
    <el-form
      ref="form"
      label-width="6em"
    >
      <iframe
        ref="iframe"
        :src="dataUrl"
        name="iframe"
        class="gameIframe"/>
    </el-form>
    <AppFormSubmit
      slot="footer"
      @submit="cancel"
      @cancel="cancel"/>
  </el-dialog>
</template>

<style lang="postcss">

    .gameIframe{
        width: 912px;
        height: 480px;
        display: block;
        margin: 0 auto;
    }
    /* 重置element-ui */

    .game-list-editor .el-form-item__content {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 40px;
    }

    .game-list-editor .el-input {
        flex-grow: 1;
    }

    .game-list-editor .el-input__inner {
        border-radius: var(--bd-radius);
    }

    /* 组件样式 */

    .game-list-editor__recorder .app-create-label {
        margin-right: 10px;
    }

    .game-list-editor__recorder .iconfont {
        font-size: 20px;
        margin: 0 10px;
    }

    .game-list-editor__recorder:nth-child(2)
    .el-form-item__content > .app-icon {
        visibility: hidden;
    }

    .game-list-editor__recorder-append {
        margin-bottom: 0 !important;
    }

    .game-list-editor__recorder-append .el-form-item__content {
        margin-left: 20px !important;
        display: flex;
        justify-content: center;
    }

    .game-list-editor__control.el-button {
        margin-left: 20px;
    }
    .textarea .el-form-item__content{
        height: 55px !important;
    }
    .select_box .el-select{
        width: 100% !important;
    }
    .game_img .dialog{
        width: 100% !important;
    }
</style>
